import _ from 'lodash'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

// http://playable.dev.com:8067/?doc=material/basic.go

export function fecthBasicList(params) {
  return request({
    url: `${v2Host}/material/basic/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 获取基础包详情
 * @param {{id: string}} params
 */
export function fecthBasicInfo(params) {
  return request({
    url: `${v2Host}/material/basic/info`,
    method: 'get',
    params: params,
  })
}

/**
 * 更新基础包
 * @param {{id: number, zip_url?: string, origin_name?: string, tag_ids?: string|array}} data
 */
export function updateBasicPackage(data = {}) {
  if (_.isArray(data.tag_ids)) data.tag_ids = data.tag_ids.join()

  return request({
    url: `${v2Host}/material/basic/update?id=${data.id}`,
    method: 'post',
    data: data,
    withoutError: 1,
  })
}

/**
 * 删除基础包
 * http://playable.dev.com:8067/?doc=material/basic.go#%2fmaterial%2fbasic%2fdelete
 * @param {{id: number}} data
 */
export function deleteBasic(data) {
  return request({
    url: `${v2Host}/material/basic/delete?id=${data.id}`,
    method: 'post',
  })
}

/**
 * 基础包重新检测
 * http://playable.dev.com:8067/?doc=material/api%2fmaterial%2fbasic.go#-material-basic-detect
 * @param {{id: number}} data
 */
export function detectBasic(data) {
  return request({
    url: `${v2Host}/material/basic/detect?id=${data.id}`,
    method: 'post',
  })
}
